import { SubscriptionsApi } from 'api/subscriptionsApi';
import { UpgradeSubscriptionsList } from 'pages/subscriptions/models';
import { useState, useCallback, useEffect } from 'react';

export const useFetchUpgradeSubscriptionsList = (id: number) => {
  const [subscriptionsListInfo, setSubscriptionsListInfo] = useState<{
    vatRate: string | null;
    upgradeList: UpgradeSubscriptionsList;
    financeEmail: string;
  } | null>(null);
  const [errors, setErrors] = useState<string>('');

  const getSubscriptionsList = useCallback(async () => {
    const result = await SubscriptionsApi.getUpgradeSubscriptionsList(id);

    if (result) {
      if (!result.data && !result.error)
        setSubscriptionsListInfo({ vatRate: null, upgradeList: [], financeEmail: '' });
      if (result.data) setSubscriptionsListInfo(result.data);
    }

    if (result.error) {
      setErrors(result.errors);
    }
  }, []);

  useEffect(() => {
    getSubscriptionsList();
  }, [getSubscriptionsList]);

  return { subscriptionsListInfo, errors };
};
